import toast from "react-hot-toast";
import { useFileUpload } from "../api/useProducts/useFileUpload";

const useSingleFileUpload = () => {
  const { mutate: singleFileUpload, isPending: isUploading } = useFileUpload(); // Use `FormData` as the input type here

  const uploadImage = async (imageFile: File | null, directory?: string): Promise<any> => {
    if (!imageFile) {
      toast.error("No file selected");
      return null;
    }

    // Create a FormData instance
    const formData = new FormData();
    formData.append("file", imageFile); // Append the file
    formData.append("directory", directory ?? "general"); // Append the directory

    return new Promise((resolve, reject) => {
      singleFileUpload(formData, {
        onSuccess: (res: any) => {
          resolve(res);
        },
        onError: (error: any) => {
          const errorMessage =
            error.response?.data?.message || "Image upload failed";
          toast.error(errorMessage);
          reject(error);
        },
      });
    });
  };

  return { uploadImage, isUploading };
};

export default useSingleFileUpload;
